import { render, staticRenderFns } from "./TelaComImagem.vue?vue&type=template&id=5a947efa&style=true&"
import script from "./TelaComImagem.vue?vue&type=script&lang=js&"
export * from "./TelaComImagem.vue?vue&type=script&lang=js&"
import style0 from "./TelaComImagem.vue?vue&type=style&index=0&id=5a947efa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports